import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'

import { onCloseQuoteRequestPublishedErrorDialog } from './QuoteRequestPublishedErrorDialog.actions'
import { CircleErrorIcon, DialogWrapper, Row } from './QuoteRequestPublishedErrorDialog.styles'

import { topPage } from '../../modules/utils/topPage'
import { inIframe } from '../../modules/utils/inIframe'

/**
 * The QuoteRequestPublishedErrorDialog's container.
 */
const QuoteRequestPublishedErrorDialog = () => {
  const { open } = useSelector(state => state.quoteRequestPublishedErrorDialog)
  const dispatch = useDispatch()

  const isInIframe = useMemo(() => inIframe(), [])

  const handleClickCloseDialog = () => dispatch(onCloseQuoteRequestPublishedErrorDialog())

  useEffect(() => topPage(isInIframe, open), [open])

  return (
    <Dialog disableBackdropClick open={open} verticalAlign="top" onClose={handleClickCloseDialog}>
      <DialogWrapper>
        <CircleErrorIcon fontSize="64px" />
        <Row>
          <Typography fontWeight="bold" variant="h4">
            Tu solicitud no pudo ser publicada
          </Typography>
          <Typography margin="16px 0 0" variant="body2">
            Lo sentimos, no pudimos publicar tu solicitud, por favor inténtalo en unos minutos más.
          </Typography>
        </Row>
        <Row>
          <Button onClick={handleClickCloseDialog} variant="contained">
            Volver
          </Button>
        </Row>
      </DialogWrapper>
    </Dialog>
  )
}

export default QuoteRequestPublishedErrorDialog
